import {inject} from "@angular/core";
import {CONNECTION_STATUS_CONFIG} from "../../../_config/connection-status";
import {fromEvent, merge, of, Subject, takeUntil} from "rxjs";
import {map} from "rxjs/operators";
import {ToastrService} from "ngx-toastr";
import {TranslateService} from "@ngx-translate/core";

export class ConnectionStatusService {

    //DI
    private toastrService: ToastrService = inject(ToastrService);
    private translateService: TranslateService = inject(TranslateService);
    private destroyer$: Subject<any> = new Subject<any>();

    networkStatus: boolean = false;

    startListener() {
        if (!CONNECTION_STATUS_CONFIG.enabled) {
            return;
        }

        let showStatusOnFirstLoad = CONNECTION_STATUS_CONFIG.showStatusOnFirstLoad || false;
        let showSuccessStatusOnFirstLoad = CONNECTION_STATUS_CONFIG.showSuccessStatusOnFirstLoad || false;

        let isFirstLoad = true;
        this.networkStatus = navigator.onLine;

        const onlineTitle = this.translateService.instant('TEXT.ONLINE_TITLE');
        const onlineMessage = this.translateService.instant('TEXT.ONLINE_MESSAGE');

        const offlineTitle = this.translateService.instant('TEXT.OFFLINE_TITLE');
        const offlineMessage = this.translateService.instant('TEXT.OFFLINE_MESSAGE');

        merge(
            of(null),
            fromEvent(window, 'online'),
            fromEvent(window, 'offline')
        )
            .pipe(
                takeUntil(this.destroyer$),
                map(() => navigator.onLine),
            )
            .subscribe({
                next: status => {

                    this.networkStatus = status;
                    if (showStatusOnFirstLoad && !this.networkStatus) {
                        this.toastrService.show(offlineMessage, offlineTitle, {toastClass: 'ngx-toastr connection-warning'});
                    }

                    if (
                        (isFirstLoad && showSuccessStatusOnFirstLoad && showStatusOnFirstLoad && this.networkStatus)
                        || !isFirstLoad && this.networkStatus) {
                        this.toastrService.show(onlineMessage, onlineTitle, {toastClass: 'ngx-toastr connection-success'});
                    }

                    isFirstLoad = false;

                },
            });
    }

    stopListener() {
        this.destroyer$.next(null);
        this.destroyer$.complete();
    }


}
